import { useI18n } from "../../i18n/I18nProvider";
import { Button, type ButtonVariant } from "./Button";
import { ErrorText } from "./feedback";
import { Modal } from "./Modal";

export interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  variant?: ButtonVariant;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  error?: unknown;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  variant = "primary",
  onConfirm,
  onCancel,
  busy = false,
  error,
}: ConfirmDialogProps) {
  const { t } = useI18n();
  return (
    <Modal title={title} onClose={onCancel}>
      <p className="mb-5 text-sm text-muted">{message}</p>
      <ErrorText error={error} />
      <div className="flex justify-end gap-2">
        <Button onClick={onCancel} disabled={busy}>
          {t("common.cancel")}
        </Button>
        <Button variant={variant} onClick={onConfirm} disabled={busy}>
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
